import { Tea } from "./core";
function initTea(initOpts) {
  console.warn("[Tea][Runtime] `initTea` is deprecated, please us `Tea.init` instead.");
  Tea.init(initOpts);
  return Tea;
}
export * from "./core";
export {
  initTea
};

//# sourceMappingURL=index.js.map